import gql from 'graphql-tag';

export const GET_PERMISSIONS = gql`
  query getPermissions {
    getPermissions {
      hasPermissions
    }
  }
`;
